import {
  cancelReasonsDryRunValues,
  mapDropdownValues,
} from '@lp/features/modals/CaseCancelModals/DeclineServiceModal/config';
import { CaseStatus, OutcomeType, TurndownOutcome } from '@/api/apis/case';
import { dryRunReasonNames } from '@/constants/case/case.constants';
import { getNameValuesFromEnumNames } from '@/utils/helpers';

export const abortedStatuses = [
  CaseStatus.ClinicalScreening,
  CaseStatus.Accepted,
  CaseStatus.PendingLogistics,
  CaseStatus.ResourcesBooked,
];
export const dryRunStatuses = [CaseStatus.ResourceDeployed, CaseStatus.AtDonorHospital];
export const turndownStatuses = [CaseStatus.OrganOnOCS, CaseStatus.DeployedToTXCenter, CaseStatus.AtTXCenter];

export const getCaseDeclineOptions = (status: CaseStatus) => {
  return [
    { value: OutcomeType.Aborted, name: 'Aborted', disabled: !abortedStatuses.includes(status) },
    { value: OutcomeType.DryRun, name: 'Dry run', disabled: !dryRunStatuses.includes(status) },
    { value: OutcomeType.Turndown, name: 'Turndown', disabled: !turndownStatuses.includes(status) },
  ];
};

const turndownOutcomeOptions = {
  [TurndownOutcome.DiscardOrgan]: 'Discard Organ',
  [TurndownOutcome.ShipOrgan]: 'Ship Organ',
};

export const CaseTurndownOutcomes = getNameValuesFromEnumNames(turndownOutcomeOptions);

export const cancelReasonsForDryRun = mapDropdownValues(cancelReasonsDryRunValues, dryRunReasonNames);

export const DISPOSITION_COMMENT_MAX_LENGTH = 1024;
